import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="fixed bottom-0 w-full z-50 pointer-events-none">
      <div className="max-w-7xl mx-auto px-8 py-3 flex justify-between items-end">
        <div className="pointer-events-auto">
          <p className="font-headline text-xs italic text-slate-500">
            &copy; 2026 Digital Field Journal
          </p>
        </div>
        <div className="flex gap-3 pointer-events-auto">
          <Link to="/sources" className="px-2 py-1 bg-surface-container/80 backdrop-blur-md rounded-lg text-[9px] font-label uppercase tracking-[0.15em] text-slate-600 hover:text-slate-400 transition-colors">
            Sources
          </Link>
          <Link to="/admin/login" className="px-2 py-1 bg-surface-container/80 backdrop-blur-md rounded-lg text-[9px] font-label uppercase tracking-[0.15em] text-slate-600 hover:text-slate-400 transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
